/**
 * Province centroid marker for Spain / Thailand GTG map (Leaflet).
 */
import React, { useMemo } from "react";
import { Marker, Tooltip } from "react-leaflet";
import L from "leaflet";
import { useTheme } from "@mui/material/styles";

const HIT_PX = 44;
const DOT_PX = 24;

function createIcon(isSelected, theme) {
  const color = isSelected ? theme.palette.success.main : theme.palette.primary.main;
  return L.divIcon({
    className: "gtg-province-marker-leaflet",
    html: `<div style="width:${HIT_PX}px;height:${HIT_PX}px;display:flex;align-items:center;justify-content:center;cursor:pointer;touch-action:manipulation;"><div style="width:${DOT_PX}px;height:${DOT_PX}px;background-color:${color};border-radius:50%;border:3px solid #fff;box-shadow:0 2px 10px rgba(0,0,0,0.35);"></div></div>`,
    iconSize: [HIT_PX, HIT_PX],
    iconAnchor: [HIT_PX / 2, HIT_PX / 2],
  });
}

const GtgProvinceMapMarker = ({
  provinceKey,
  displayName,
  lat,
  lng,
  isSelected,
  onOpenDetail,
  disabled = false,
}) => {
  const theme = useTheme();
  const icon = useMemo(() => createIcon(isSelected, theme), [isSelected, theme]);
  const tip = `${displayName} — click for details and add to list`;

  return (
    <Marker
      position={[lat, lng]}
      icon={icon}
      interactive={!disabled}
      eventHandlers={{
        click: (e) => {
          if (disabled) return;
          e?.originalEvent?.stopPropagation?.();
          onOpenDetail?.(provinceKey);
        },
      }}
    >
      <Tooltip direction="top" offset={[0, -18]}>
        {tip}
      </Tooltip>
    </Marker>
  );
};

export default GtgProvinceMapMarker;
